import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import update from 'immutability-helper'
import TextTruncate from 'react-text-truncate'

import Icon from 'Pods/Shared/Icon/Icon'
import ImageSorting from 'Pods/Shared/ImageSorting/ImageSorting'

const Image = ({
  id, url, imageProps, onRemove,
}) => {
  return (
    <Fragment>
      <div className="image-wrapper">
        <div className="delete-image is-hidden-when-sortable">
          <span onClick={(e) => onRemove(e, id)}>
            <Icon type={['far', 'times']} className="ml-5 is-bigger" />
          </span>
        </div>
        <img src={url} />
      </div>

      {imageProps.fileName && (
        <TextTruncate
          text={imageProps.fileName}
          truncateText="…"
          containerClassName="image-container__title is-hidden-when-sortable"
          line={1}
        />
      )}
    </Fragment>
  )
}

const dropSpace = (
  <div className="col-12 col-sm-6 col-md-3 col-xl-2 u-mb10">
    <div className="image-container is-placeholder">
      <div className="image-wrapper">&nbsp;</div>
    </div>
  </div>
)

class ImagesList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      images: props.images || [],
      selectedImagesIds: [],
      removedImageIds: props.removedImageIds,
    }

    this.onImagesChange = this.onImagesChange.bind(this)
    this.onSelectionChange = this.onSelectionChange.bind(this)
    this.onImageClick = this.onImageClick.bind(this)
    this.removeImages = this.removeImages.bind(this)
    this.onRemoveImageSuccess = this.onRemoveImageSuccess.bind(this)
    this.onSortEnd = this.onSortEnd.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.images !== this.props.images) {
      this.setState({ images: this.props.images })
    }
  }

  onSelectionChange(selectedImagesIds) {
    this.setState({ selectedImagesIds })
  }

  onImageClick(id) {
    let selected = this.state.selectedImagesIds

    if (selected.includes(id)) {
      selected = selected.filter(selectedId => selectedId !== id)
    } else {
      selected.push(id)
    }

    this.setState({ selectedImagesIds: selected })
  }

  removeImages(e, id = 0) {
    e.stopPropagation()

    if (this.props.itemStatus === 'published' && (this.state.images.length === 1 || this.state.images.length === this.state.selectedImagesIds.length)) {
      App.events.publish('app:notification:flash:error', 'You cannot delete all images from a published model.')
      return null
    }

    if (Number(id) > 0) {
      axios.delete(`/api/internal/items/${this.props.itemId}/images/${id}`)
        .then(this.onRemoveImageSuccess(id))
        .catch((error) => {})
    } else {
      this.state.selectedImagesIds.forEach((imageId) => {
        axios.delete(`/api/internal/items/${this.props.itemId}/images/${imageId}`)
          .then(this.onRemoveImageSuccess(imageId))
          .catch((error) => {})
      })
    }
  }

  onImagesChange(images, removedImageIds, needsFiltering = false) {
    if (needsFiltering) {
      const filteredImages = []

      images.map(image => {
        if (!removedImageIds.includes(image.id)) {
          filteredImages.push(image)
        }
      })

      this.props.onChange(filteredImages, removedImageIds)
    } else {
      this.props.onChange(images, removedImageIds)
    }
  }

  onRemoveImageSuccess(removableImageId) {
    const currentState = this.state
    const images = currentState.images.filter(image => image.id !== removableImageId)
    const selectedImagesIds = currentState.selectedImagesIds.filter(id => id !== removableImageId)
    const removedImageIds = currentState.removedImageIds

    removedImageIds.push(removableImageId)

    this.setState({
      images,
      selectedImagesIds,
      removedImageIds,
    })

    this.onImagesChange(images, removedImageIds, true)
  }

  onSortEnd(newImagesOrder) {
    const sortedImages = newImagesOrder.map((imageId) => {
      return this.state.images.find((image) => image.id === imageId)
    })

    this.setState({ images: sortedImages })

    this.onImagesChange(sortedImages, this.state.removedImageIds)
  }

  render() {
    return (
      <div className="sortable-images-list">
        <div className="images__header u-mb10">
          <span className="text-semibold thumbnail-text">Thumbnail</span>
          <div className="header-actions u-text-right">
            <span className="header-tip">
              <span className="text-semibold header-tip--dark">Tip:</span> cmd/shift+click to mark and drag multiple images
            </span>
            <button
              type="button"
              className="btn btn-outline-default btn-sm u-ml10"
              disabled={this.state.selectedImagesIds.length < 1}
              onClick={this.removeImages}
            >
              Delete selected
            </button>
          </div>
        </div>

        <ImageSorting
          className="row"
          images={this.state.images.map((data) => ({
            id: data.id, url: data.url, isAdultContent: data.isAdultContent, fileName: data.fileName,
          }))}
          imageComponent={Image}
          onDragStateChange={this.props.onDragStateChange}
          onChange={this.onSortEnd}
          onSelectionChange={this.onSelectionChange}
          onRemove={this.removeImages}
          spaceComponent={dropSpace}
          containerSizes="col-12 col-sm-6 col-md-3 col-xl-2"
        />
      </div>
    )
  }
}

ImagesList.propTypes = {
  itemId: PropTypes.string.isRequired,
  itemStatus: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      isAdultContent: PropTypes.bool.isRequired,
      fileName: PropTypes.string,
    }).isRequired
  ).isRequired,
  removedImageIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  updateImageAdultAttr: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onDragStateChange: PropTypes.func.isRequired,
  isAdultContentChecked: PropTypes.bool.isRequired,
}

ImagesList.defaultProps = {
  images: [{
    fileName: '',
  }],
}

export default ImagesList
